import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../components/ui/SectionHeading';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
const resources = {
  directories: [{
    name: 'API Composite List',
    url: 'https://mycerts.api.org/Search/CompositeList',
    desc: 'API-licensed manufacturers and service providers.'
  }, {
    name: 'Rigzone Directory',
    url: 'https://www.rigzone.com/companies/',
    desc: 'Oil & gas companies, services, and equipment.'
  }, {
    name: 'Thomasnet',
    url: 'https://www.thomasnet.com/',
    desc: 'Industrial supplier and product discovery.'
  }, {
    name: 'GlobalSpec',
    url: 'https://www.globalspec.com/',
    desc: 'Engineering and industrial product search.'
  }, {
    name: 'EPA Natural Gas STAR',
    url: 'https://www.epa.gov/natural-gas-star-program',
    desc: 'Methane reduction provider directory.'
  }],
  compliance: [{
    name: 'OFAC Sanctions Search',
    url: 'https://sanctionssearch.ofac.treas.gov/',
    desc: 'U.S. Treasury sanctioned persons and entities.'
  }, {
    name: 'OFAC Venezuela Program',
    url: 'https://ofac.treasury.gov/sanctions-programs-and-country-information/venezuela-sanctions',
    desc: 'Active OFAC Venezuela sanctions program details.'
  }, {
    name: 'BIS Entity List',
    url: 'https://www.bis.doc.gov/index.php/policy-guidance/lists-of-parties-of-concern/entity-list',
    desc: 'U.S. Commerce export-restricted parties.'
  }, {
    name: 'Consolidated Screening List',
    url: 'https://www.trade.gov/consolidated-screening-list',
    desc: 'Combined U.S. export control screening list.'
  }],
  certifications: [{
    name: 'API Standards',
    url: 'https://www.api.org/products-and-services/standards',
    desc: 'American Petroleum Institute standards.'
  }, {
    name: 'ISO Standards',
    url: 'https://www.iso.org/standards.html',
    desc: 'International quality and environmental standards.'
  }, {
    name: 'ASME',
    url: 'https://www.asme.org/codes-standards',
    desc: 'Pressure equipment and mechanical standards.'
  }, {
    name: 'OSHA',
    url: 'https://www.osha.gov/',
    desc: 'U.S. occupational safety and health administration.'
  }]
};
export function ResourcesPage() {
  const {
    lang
  } = useLang();
  const t = dictionary.resources;
  const sections = [{
    key: 'directories' as const,
    title: t.categories.directories[lang]
  }, {
    key: 'compliance' as const,
    title: t.categories.compliance[lang]
  }, {
    key: 'certifications' as const,
    title: t.categories.certifications[lang]
  }];
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-786">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-787">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-788" />

        <div className="mt-14 space-y-12" data-id="element-789">
          {sections.map(sec => <section key={sec.key} data-id="element-790">
              <h2 className="font-serif text-2xl text-navy-deep mb-5" data-id="element-791">
                {sec.title}
              </h2>
              <div className="grid md:grid-cols-2 gap-3" data-id="element-792">
                {resources[sec.key].map((r, i) => <motion.a key={r.name} href={r.url} target="_blank" rel="noopener noreferrer" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.04
            }} className="group block border border-slate-200 hover:border-navy-deep/30 hover:shadow-[0_8px_24px_rgb(10,22,40,0.06)] rounded-md p-5 bg-white transition-all" data-id="element-793">
                    <div className="flex items-start justify-between gap-3 mb-2" data-id="element-794">
                      <h3 className="font-serif text-lg text-navy-deep group-hover:text-petroleum transition-colors" data-id="element-795">
                        {r.name}
                      </h3>
                      <ExternalLinkIcon className="w-4 h-4 text-slate-400 group-hover:text-gold-deep" data-id="element-796" />
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed" data-id="element-797">
                      {r.desc}
                    </p>
                    <p className="mt-3 font-mono text-[10.5px] tracking-wider text-gold-deep uppercase" data-id="element-798">
                      {t.visit[lang]} →
                    </p>
                  </motion.a>)}
              </div>
            </section>)}
        </div>
      </div>
    </main>;
}